import {
    Flex,
    Stack,
    Container,
    Image,
    Heading,
    Text
} from '@chakra-ui/react'

import theme from '../../../../Config/theme'

import NotFoundIcon from '../../../../Assets/not_found.svg'

const ScholarshipsNotFound = () => {
    return (
        <Flex w={'full'} h={'40vh'} >
            <Container maxW={'5xl'}>
                <Stack direction={'column'} align={'center'} textAlign={'center'} spacing={5}>
                    <Image src={NotFoundIcon} h={40} />
                    <Stack direction={'column'} align={'center'} spacing={0}>
                        <Heading fontSize={'3xl'} fontWeight={700} >No scholarships found</Heading>
                        <Text color={'gray.600'}>Try using different keywords or filters.</Text>
                    </Stack>
                </Stack>
            </Container>
        </Flex>
    )
}

export default ScholarshipsNotFound